import React, { Component } from 'react';
import LayoutWrapper from "../../../components/utility/layoutWrapper";
import { Breadcrumb } from "antd";
import IntlMessages from '../../../components/utility/intlMessages';
import Box from "../../../components/utility/box";
import UserProfile from './userProfile';

export default class userProfile extends Component {
    render() {
        return (
            <LayoutWrapper>
                <div style={{ paddingBottom: 20 }}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <IntlMessages id="themeSwitcher.settings" />
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <Box>
                    <div>
                        <div style={{
                            fontSize: 24,
                            fontFamily: "Kanit",
                            paddingBottom: 10,
                        }}>
                            ข้อมูลผู้ใช้
                    </div>
                        <UserProfile />
                    </div>
                </Box>

            </LayoutWrapper>
        )
    }
}
